import React from 'react';
import Cookies from "js-cookie";
import { createContext, useReducer } from "react";


export const Store = createContext()
const initialState = {
  userInfo: Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')) : null,
}

function reducer(state, action){
  switch(action.type) {
    case 'USER_LOGIN': {
      return { ...state, userInfo: action.payload }
    }
    case 'USER_LOGOUT': {
      return { ...state, userInfo: null }
    }
    case 'ACCESS_TOKEN': {
      return { ...state, accessToken: action.payload }
    }
    case 'REMOVE_ACCESS_TOKEN': {
      return { ...state, accessToken: null }
    }
    case 'USER_EDIT': {
      return { ...state, userEdit: action.payload }
    }
    case 'EVENT_EDIT': {
      return { ...state, eventEdit: action.payload }
    }
    case 'TYPE_DATA': {
      // for data in autocomplete, multicomplete
      return { ...state, typeData: action.payload }
    }
    case 'CATEGORY_DATA': {
      // for data in autocomplete, multicomplete
      return { ...state, categoryData: action.payload }
    }
    case 'CONNECTIONS_LIST': {
      return { ...state, connectionsList: action.payload }
    }
    default:
      return state
  }
}

export function StoreProvider(props){
  const [state, dispatch] = useReducer(reducer, initialState)
  const value = { state, dispatch }
  return (<Store.Provider value={value}>{props.children}</Store.Provider>)
}